import React from "react";
import ReactDOM from "react-dom/client";
import "@/lib/fonts"; // Phase 86 — auto-hébergement des polices (RGPD-clean)
import "@/index.css";
import App from "@/App";
import { registerServiceWorker } from "@/lib/serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Phase 101fk.4 (Feb 2026) — PWA installable (SW + cache shell + offline)
registerServiceWorker();
